import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["template", "fields", "field"]

    add(event) {
        event.preventDefault()
        let content;

        if (event.params && event.params.templateClass) {
            const template = this.element.querySelector(`.${event.params.templateClass}`)
            content = template.innerHTML.replace(/NEW_RECORD/g, new Date().getTime())
        } else {
            content = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, new Date().getTime())
        }

        this.fieldsTarget.insertAdjacentHTML('beforeend', content)
    }

    remove(event) {
        event.preventDefault()
        const field = event.target.closest('[data-nested-form-target="field"]')

        // If it's a persisted record, mark it for deletion
        const destroyInput = field.querySelector('input[name*="[_destroy]"]')
        if (destroyInput) {
            destroyInput.value = '1'
            field.style.display = 'none'
        } else {
            field.remove()
        }
    }
}
